import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SignUpService } from '@app/core/services/signUp/signUp.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { TurnstileService } from '@app/core/services/turnstile/turnstile.service';
import { ResetPassword } from '@app/shared/validators/reset-passsword';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TextDialogueComponent } from '@app/auth/TextDialogue/TextDialogue.component';
import { LoginAndSignUpDataComponent, PopupService } from '@app/shared/services/popup/popup.service';

declare var $: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit, AfterViewInit {
  signUpForm: FormGroup;
  captchaError: boolean = false;
  turnstileToken: string = '';

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private loaderService: LoaderService,
    private notification: NotificationService,
    private signupService: SignUpService,
    private turnstileService: TurnstileService,
    public SignUpDialogRef: MatDialogRef<SignupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoginAndSignUpDataComponent,
    private popupService: PopupService,
    public dialog: MatDialog,) {
    this.signUpForm = this.formBuilder.group({
      FirstName: ['', Validators.compose([Validators.required])],
      LastName: ['', Validators.compose([Validators.required])],
      Email: ['', Validators.compose([Validators.required,
      Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,3})$')])],
      ContactNo: ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]*$'),
      Validators.minLength(10), Validators.maxLength(10)])],
      Password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      ConfirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      SiteActive: [true],
      IsInvitation: [false],
      Website: [''] // Honeypot field - hidden from real users, bots will fill this
    }, {
      // validator: MatchPassword.MatchPassword.bind(this)
      validator: ResetPassword.ResetPassword
    });
    if (this.data.isInvitation) {
      this.signUpForm.controls.Email.setValue(this.data.invitedEmail);
    }

  }

  ngOnInit() {
    $(".body").css("filter", "blur(5px)");
  }

  ngAfterViewInit() {
    console.log('SignupComponent: ngAfterViewInit called');
    // Render Turnstile after view is initialized with longer delay for dialog animation
    setTimeout(() => {
      console.log('SignupComponent: setTimeout callback executing');
      const container = document.getElementById('turnstile-container');
      if (!container) {
        console.error('Turnstile container not found');
        return;
      }
      console.log('SignupComponent: Found turnstile-container, rendering captcha');

      this.turnstileService.renderCaptcha(
        'turnstile-container',
        (token: string) => {
          console.log('SignupComponent: Turnstile token received');
          this.turnstileToken = token;
          this.captchaError = false;
        },
        () => {
          console.log('SignupComponent: Turnstile token expired');
          this.turnstileToken = '';
        }
      ).then(() => {
        console.log('SignupComponent: Turnstile rendered successfully');
      }).catch(err => {
        console.error('Failed to render Turnstile:', err);
      });
    }, 500);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.signUpForm.controls;
  }

  onSubmit(signUpForm: FormGroup) {
    // Check if captcha is verified
    const captchaResponse = this.turnstileService.getResponse();
    if (!captchaResponse) {
      this.captchaError = true;
      this.notification.error('Please verify that you are not a robot.', 'Error');
      return;
    }

    let signUpDetails = signUpForm.value;

    if (this.data.endUser) {
      signUpDetails = {
        ...signUpDetails,
        StoreId: localStorage.getItem('storeId'),
        StoreName: localStorage.getItem('storeUrl'),
        SiteActive: true
      };
    }
    if(this.data.isInvitation){
      signUpDetails = {
        ...signUpDetails,
        SiteActive: false,
        IsInvitation: true,
        Permission: this.data.permission
      };
    }

    // Add Turnstile token (using same field name for backend compatibility)
    signUpDetails = {
      ...signUpDetails,
      RecaptchaToken: captchaResponse
    };

    this.loaderService.show();
    this.signupService.createSignUp(signUpDetails)
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          if (this.data.isInvitation) {
            this.closeDialog();
            this.notification.success('Your account has been created.', 'Success');
            this.router.navigate(['']);
          }else{
          //Lets open the confirmation email has been sent popup
          this.openDialog(signUpDetails);
          this.notification.success(res.Message, 'Register');
          }
        } else {
          this.notification.error(res.Message, 'Error');
          // Reset captcha on error
          this.turnstileService.reset();
          this.turnstileToken = '';
        }
        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.notification.error('An error occured', 'Error');
        // Reset captcha on error
        this.turnstileService.reset();
        this.turnstileToken = '';
      });

  }
  openDialog(signUpDetails) {
    var text = "Dear "
      + signUpDetails.FirstName + " " +
      signUpDetails.LastName + ", " +
      " An Email has been sent to verify your account at " +
      signUpDetails.Email + ". Please confirm your account.";

    this.dialog.open(TextDialogueComponent, {
      width: '50%',
      data: { Title: "Confirm Account", Description: text }
    });

    this.closeDialog();
  }

  fn_checkUserExist(email) {
    // Don't check if email is empty or invalid
    if (!email || email.trim() === '' || !this.signUpForm.controls.Email.valid) {
      return;
    }

    this.signupService.CheckUserExist(email)
      .subscribe((res: any) => {
        if (res.StatusCode !== 200) {
          this.notification.info(res.Message, 'Information');
          // Don't auto-redirect - let user click "Sign In" link manually
        }
        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        console.error('CheckUserExist error:', err);
        // Don't show error notification for network issues during email check
      });
  }

  openLoginWindow() {
    this.popupService.openLogin(this.data.endUser);
    this.closeDialog();
  }

  closeDialog(): void {
    console.log('SignupComponent: closeDialog() called');
    console.trace('closeDialog stack trace');
    $(".body").css("filter", "blur(0px)");
    this.SignUpDialogRef.close();
  }

}
